import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Route, RouteComponentProps, withRouter } from 'react-router';
import { SpeechesData } from '../stores';
import { SpeechesByYear } from './SpeechesByYear';
import { VideoModalView } from './VideoModalView';

@(withRouter as ClassDecorator)
@inject('speeches')
@observer
export class YearRouteComponent extends React.Component<{ speeches: SpeechesData } & Partial<RouteComponentProps<{ year: string }>>> {
    render() {
        const { speeches, match } = this.props;
        return (
            <React.Fragment>
                <Route path={match.url + '/:link?'}
                       render={() => (
                           <SpeechesByYear data={speeches} year={match.params.year} />
                       )}
                />
                <Route exact path={match.path + '/:link/:video'}
                       render={() => (
                           <VideoModalView url={match.url} />
                       )}
                />
            </React.Fragment>
        );
    }
}
